<div class="text-container">
  @if (hasText()) {
    <div class="publisher" [ngStyle]="source() | responsiveStyle" [content]="content()" [deltaContent]="content().typeSpecific.data.publisher.name"></div>
  }

  @if (hasLicense()) {
    <div
      class="license"
      [ngStyle]="source() | responsiveStyle"
      [innerHtml]="content().typeSpecific.data.publisher.license | linkify: { truncate: { length: 64 } }"
    ></div>
  }
</div>
